import store from "../store";
import Log from "./Log";
export function getConnectionStatus(key) {
    var connections = store.getState().connections;
    if (Object.keys(connections).length === 0) {
        Log.warn("No connections yet.");
        return 102;
    }
    if (connections[key]) {
        var _connections_key;
        return ((_connections_key = connections[key]) === null || _connections_key === void 0 ? void 0 : _connections_key.status) || 102;
    } else {
        Log.warn("Unknown Connection");
        return 0;
    }
}
